/*
 * ******************************************************************
 * Copyright (c) 2022-2026 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */

export class ConsoleStrings {
    name: string = "general.UNDEFINED_STRING";
    shortName: string = "general.UNDEFINED_STRING";
    serviceDescription: string = "general.UNDEFINED_STRING";
    htmlTitle: string = "general.UNDEFINED_STRING";
    htmlTitleDefault: string = "general.UNDEFINED_STRING";
}

export const VLR_STRINGS: ConsoleStrings = {
    name: "vlr.console.app.name",
    shortName: "vlr.console.app.name.short",
    serviceDescription: "console.slow.rollout.initial.description.vlr",
    htmlTitle: "vlr.console.html.title",
    htmlTitleDefault: "vlr.console.html.title.default"
}

export const VMCFS_STRINGS: ConsoleStrings = {
    name: "vmcfs.console.app.name",
    shortName: "vmcfs.console.app.name.short",
    serviceDescription: "console.slow.rollout.initial.description.vmcfs",
    htmlTitle: "vmcfs.console.html.title",
    htmlTitleDefault: "vmcfs.console.html.title.default"
}

export const OPERATOR_STRINGS: ConsoleStrings = {
    name: "op.console.csp.header.title",
    shortName: "op.console.csp.header.title",
    serviceDescription: "console.slow.rollout.initial.description.vlcr",
    htmlTitle: "op.console.html.title",
    htmlTitleDefault: "op.console.html.title.default"
}

export const QUORUM_STRINGS: ConsoleStrings = {
    name: "quorum.console.app.name",
    shortName: "quorum.console.app.name.short",
    serviceDescription: "quorum.console.app.description",
    htmlTitle: "quorum.console.html.title",
    htmlTitleDefault: "quorum.console.html.title.default"
}
